import { render, staticRenderFns } from "./DictionaryAcceptanceWordsNew.vue?vue&type=template&id=6df38da2&scoped=true&"
import script from "./DictionaryAcceptanceWordsNew.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWordsNew.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryAcceptanceWordsNew.vue?vue&type=style&index=0&id=6df38da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df38da2",
  null
  
)

export default component.exports